import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import '@/styles/common.css'
import globalComponents from '@/plugins/globalComponents'
// 👉 引入 Element Plus
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'   // 样式文件
import '@/styles/tw.css'

const app = createApp(App)

app.use(store)
app.use(router)
app.use(ElementPlus)   // 全局注册 Element Plus
app.use(globalComponents)

app.mount('#app')
